/** The bar's sign-out, as `FamilyBar` runs it: asked first, this session ended within a bound, then on */
interface Signout {
	before: () => Promise<boolean>;
	end: () => Promise<void>;
	after: () => Promise<void>;
}

/**
 * "Sign out of Beyond" when the session dialog's "Use another account" asks for it: the same steps the
 * family bar's entry takes (Q09), because the bar's own flow is not reachable from outside it. Unsaved
 * work is asked about first; this product's session ends within `BOUND` (an ended or unreachable one does
 * not hold it up, since Accounts' `/leave` ends every session of the browser); then the browser goes to
 * Accounts' `/leave` with `product` and `return`, or, without that address, signs out here only.
 */
export class Leaving {
	/** Milliseconds the product's own sign-out may take, as the bar's */
	static BOUND = 5000;

	static async run({ signout, address, location = globalThis.location }: { signout: Signout; address: string | undefined; location?: Location }): Promise<void> {
		if (!(await signout.before())) return;
		let timer: ReturnType<typeof setTimeout> | undefined;
		const late = new Promise<void>(resolve => (timer = setTimeout(resolve, Leaving.BOUND)));
		await Promise.race([signout.end().catch(() => undefined), late]);
		clearTimeout(timer);
		if (!address) return signout.after();
		const url = new URL(address, location.href);
		url.searchParams.set('product', 'snapshots');
		url.searchParams.set('return', location.href);
		location.assign(url.toString());
	}
}
